var site = site || {};

site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.dropdown = {
	init: function() {
		var $dd =  $('#main .dropdown');
		if($dd) {
			$dd.find('>ul > li').addClass('first');
		}
		$dd.find('> ul > li.first').click(function(e){
			var $p = $(this).parent();
			if($p.hasClass('open')) {
				$p.toggleClass('open');
			}
			else  {
				$dd.find('ul.open').toggleClass('open');
				$p.toggleClass('open');
			}
			e.preventDefault();
			setTimeout(function() {
				$('html, body').animate({
					scrollTop: $p.offset().top - 10
				}, 500);
			},500);
		});
	}
};

site.nav = {
	// Init navigation scripts
	init: function () {
		// Add expand link to mobile menu
		$('.children.level1 > a', '#mainmenu ').addClass('expand');

		site.nav.bind();
	},
	bind: function () {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function (e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			else {
				$('#searchBox,#mainmenu .gler').removeClass('open');
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
			e.preventDefault();
		});
		$('.menuOverlay').click(function (e) {
			$('body').removeClass('mainmenu-open');
			e.preventDefault();
		});
		// Expand in mobile menu
		$('.expand', '#mainmenu').bind('click', function (e) {
			var $this = $(this);
			var $ul = $this.siblings('ul');
			if($ul.hasClass('hide')) {
				$('#mainmenu .mmLevel2').addClass('hide');
				$ul.removeClass('hide');
			}
			else {
				$ul.toggleClass('hide');
			}

			e.preventDefault();
		});
	},
	// Toggle mobile menu
	mobileToggle: function (e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if($(window).width() < 993 ) {
			if (!menuOpen) {
				$(window).scrollTop(0);
			}
			else {
				$(window).scrollTop(scrollPosition);
			}
		}
	},
	// Append language to mobilemenu
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};


function callPlayer(iframeID, func, args) {
	var iframe = $('#'+iframeID)[0];
	if ( iframe.src.indexOf('youtube.com/embed') !== -1) {
		iframe.contentWindow.postMessage( JSON.stringify({
			'event': 'command',
			'func': func,
			'args': args || []
		} ), '*');
	}
}

function callVimeoPlayer(iframeID, func, args) {
	if (typeof $f === 'undefined') {
		return;
	}
	var iframe = $('#'+iframeID)[0];
	var player = $f(iframe);

	if(player) {
		player.api(func,args);
	}
}

site.frontpage = {
	init: function () {
		var owlOptions = {
			loop: false,
			dots: false,
			nav: true,
			navText: ["", ""],
			items: 1,
			/*onInitialized: playVideo,*/
			onChange: stopVideoVimeo,
			onChanged: playVideoVimeo
		};
		var $owl = $('#owl-hero');
		if ($owl.length > 0) {
			$owl.on('initialized.owl.carousel',function(property) {
				var players = getVideos();
				if(players) {
					$.each(players, function(i,value){
						var iframe = $('iframe#'+value);
						iframe.attr('src',iframe.data('src'));
						if(i > 0) {
							/*stopVideoVimeo(value);*/
							$('#'+value).load(function() {
								callVimeoPlayer(value, "pause");
							});
						}
					});
				}

				var src = site.frontpage.video(property);
				if(src) {
					var iframe = $('#'+src)[0];
					var player = $f(iframe);

					player.addEvent('ready',function(src) {
						muterVimeo($('.owl-item.active .sound'));
					});

					/* Youtube
					$('#'+src).load(function(){muter($('.owl-item.active .sound'));});
					*/
				}

			});
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(owlOptions);
		}


		function playVideoVimeo(property) {
			var src = site.frontpage.video(property);
			if(src) {
				callVimeoPlayer(src, "play");
			}
		}

		function playVideo(property) {
			var src = site.frontpage.video(property);
			if(src) {
				callPlayer(src,"playVideo");
			}
		}

		function stopVideoVimeo(property) {
			var src = site.frontpage.video(property);
			if(src) {
				callVimeoPlayer(src,"pause");
			}
		}

		function stopVideo(property) {
			var src = site.frontpage.video(property);
			if(src) {
				callPlayer(src,"stopVideo");
			}
		}

		function muterVimeo(event) {
			$this = event;
			var players = getVideos();
			if($this.hasClass('muted')) {
				$.each(players, function(i,value){
					callVimeoPlayer(value,"setVolume",0.5);
					$this.removeClass('muted');
				});
				$('#banner .sound').removeClass('muted');
			}
			else {
				$.each(players, function(i,value){
					callVimeoPlayer(value,"setVolume",0);
					$this.addClass('muted');
				});
				$('#banner .sound').addClass('muted');
			}
		}

		function muter(event) {
			$this = event;
			var players = getVideos();
			if($this.hasClass('muted')) {
				$.each(players, function(i,value){
					callPlayer(value,"unMute");
					$this.removeClass('muted');
				});
				$('#banner .sound').removeClass('muted');
			}
			else {
				$.each(players, function(i,value){
					callPlayer(value,"mute");
					$this.addClass('muted');
				});
				$('#banner .sound').addClass('muted');
			}
		}

		$('#banner .sound').click(function(e){
			$this = $(this);
			muterVimeo(e);

			e.preventDefault();
		});


		$('body').addClass('atTop');
		var wh = $(window).height();
		$(window).scroll(function (event) {
			var scroll = $(window).scrollTop();
			if (scroll > wh) {
				$('body').removeClass('atTop');
				var players = getVideos();
				$.each(players, function(i,value){
					callVimeoPlayer(value,"pause");
				});
			}
			else {
				$('body').addClass('atTop');
				callVimeoPlayer($('#owl-hero .active iframe').attr('id'),"play");
			}
		});
		$heros = $('#owl-hero');
		$heros.find('.down a ').click(function (e) {
			e.preventDefault();
			$('html, body').animate({scrollTop: $('#owl-hero').height()}, 'slow');
		});
		var instaOptions = {
			/*mousewheelScrolling: "allDirections",*/
			manualContinuousScrolling: true,
			autoScrollingMode: "onStart"
		}

		/* Touch/desktop options */
		if($(window).width() > 1024 ){
			$.extend(instaOptions, {
				hotSpotScrolling: true,
				touchScrolling: false
			});
		} else {
			$.extend(instaOptions, {
				hotSpotScrolling: false,
				touchScrolling: true
			});
		}

		$("#makeMeScrollable").smoothDivScroll(instaOptions);
		$(window).load(function(){
			$("#makeMeScrollable").smoothDivScroll("stopAutoScrolling");
		});

		site.frontpage.tiles();
		/*site.frontpage.events();*/
		//site.frontpage.map();
	},
	video: function(property) {
		var current = property.item.index;
		var src = $(property.target).find(".owl-item").eq(current).find("iframe").attr('id');
		return src;
	},
	tiles: function() {
		$('#heroTiles > ul > li,#tilesDeli > ul > li').hoverdir({speed:800});
	},
	events: function() {
		$event = $('#events');
		$event.find('.eventMore a').click(function(e) {
			$event.toggleClass('open');
			e.preventDefault();
		});
	}
};

function getVideos() {
	var players = [];
	$('#owl-hero').find('.item.video').each(function(i, value) {
		$this = $(this);
		players[i] = $this.find('iframe').attr('id');
	});
	return players;
}

function isFront() {
	return $('body').is('.frontpage');
}

// Run all the inits \o/
$(function () {


	site.nav.init();
	site.dropdown.init();

	// Responsive tables
	let $body = $('body');
	if (!$body.is('.admin') && !$body.is('.frontpage')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').bind('click', function (e) {
		e.preventDefault();
		window.location = '/moya';
	});

	if (isFront()) {
		site.frontpage.init();
		/*site.frontpage.video();*/

		$.each(site.inits, function(i, value) {
			var fun = new Function(value);
			fun();
		});

	}
	$('#mainmenu .gler').click(function() {
		$this = $(this);
		$s = $('#searchBox');
		if(!$this.hasClass('open')) {
			$s.find('#q').focus();
		}
		$this.toggleClass('open');
		$s.toggleClass('open');
	});

	//Responsive youtube and vimeo iframe
	if (!$('body').is('.frontpage')) {
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
			$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
		});
	}

	// Note
	fixBg();
	var gw = $(window).width();
	var gh = $(window).height();
	$(window).on('resize',function() {
		if($(window).width() != gw || $(window).height() != gh) {
			fixBg();
		}
	});


	$('#mainmenu .menuWrap').slimScroll({
		height:'100%',
		color:"#96b7c5"
	});
});

function fixBg() {
	var $note = $('#note').find('.noteInner');
	var $albums = $('#sidebar .sidebarAlbums');
	var vw = $(window).width();
	var vh = $(window).height();
	/*var vh = $('body').height();*/
	var sw = $('#sidebar').width();
	var calc = (vw - $note.width())/2;
	$('#mainmenu2').width(sw);
	if(vw > 768) {
		$note.parent().height(vh);
		$note.find('.bg').css('padding-right',calc);
		$albums.height(vh).css('marginLeft',-1*calc);
		$albums.find('.albumImages').width($albums.width());
		$albums.find('.albumImages').height(vh);
		$albums.find('.albumOverlay').width($albums.width());
	}
	gw = vw;
	gh = vh;
}
function onYouTubeIframeAPIReady() {

}
